export const DEFAULT_HOME_PATH = '/home/discover'